import { type ReactNode } from 'react';
import { type FieldProps } from './signup-field-helpers';
import { PersonalFields } from './personal-fields';
import { AccountFields } from './account-fields';
import { SectionHeader } from '@/components/ui/section-header';

export type { SignupData } from './signup-field-helpers';

export function SignupFields(p: FieldProps): ReactNode {
  return (
    <div className="space-y-sm">
      <SectionHeader label="Datos personales" />
      <PersonalFields {...p} />
      <SectionHeader label="Cuenta" />
      <AccountFields {...p} />
    </div>
  );
}
